import { IFaq, IMedicalDeviceInfo } from 'src/models';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

/** 앱 최신 버전 정보 (TB_APP) */
export interface IAppVersion {
  appSid?: number;
  /** 최신 앱 버전 (예: "1.0") */
  appVer: string;
  /** 스토어 이동 URL */
  storeUrl?: string;
  /** OS 타입 (서버 저장값: "Android" | "iOS") */
  osType?: string;
  langCd?: string;
}

/** 의료기기 라벨 및 버전 조회 */
export const getMedicalDeviceInfo = async () => {
  try {
    const url = `/medicalDeviceInfo`;

    const response = await instance.get<TApiResponseData<IMedicalDeviceInfo>>(url);
    if (response.data.resultCode === 'S' && response.data.data) {
      return response.data.data;
    }
    return {} as IMedicalDeviceInfo;
  } catch (error) {
    console.error(error);
  }
};

/**
 * 앱 최신 버전 조회
 * @param osType 서버 저장값 기준 "Android" | "iOS"
 * @returns 최신 버전 정보 또는 undefined (매칭 행 없음/오류)
 */
export const getLatestAppVer = async (osType: string): Promise<IAppVersion | undefined> => {
  try {
    const url = `/app/appVer`;

    const response = await instance.get<TApiResponseData<IAppVersion>>(url, {
      params: { osType },
    });
    if (response.data.resultCode === 'S' && response.data.data) {
      return response.data.data;
    }
    return undefined;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

/** 자주 묻는 질문 */
export const getFaqList = async () => {
  try {
    const url = `/faq`;

    const response = await instance.get<TApiResponseData<IFaq[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
